import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { IHttpClient } from 'utils/http/httpClient.model';

export interface AppFeedbackConfiguration {
  url: string;
}
export interface AppFeedbackResponse {
  data: AppFeedbackConfiguration;
}
export function appFeedbackApi(http: IHttpClient) {
  return {
    getConfiguration(): Observable<AppFeedbackResponse> {
      return http
        .getJSON<AppFeedbackResponse>({
          url: `api/v1/app-feedback/configuration`,
        })
        .pipe(
          map(response => {
            return response.payload;
          }),
        );
    },
  };
}
